import { useEffect } from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary.js";
import {AuthProvider} from "../context/AuthContext.js";
import {StoreProvider} from "../context/StoreContext.js";
import {ThemeProvider} from "../context/ThemeContext.js";
import {LanguageProvider} from "../context/LanguageContext.js";
import {SidebarProvider} from "../context/SidebarContext.js";
import {RealtimeProvider} from "../context/RealtimeContext.js";
import { fetchPublicSettings } from "../api/settingAPI.js";
import { setCurrencyConfig } from "./Currency.js";

function CurrencyBootstrap({ children }) {
    useEffect(() => {
        let isMounted = true;

        const syncCurrencySettings = async () => {
            try {
                const publicSettings = await fetchPublicSettings();
                if (!isMounted || !publicSettings) return;

                setCurrencyConfig({
                    locale: publicSettings.locale,
                    currency: publicSettings.currency,
                });
            } catch (error) {
                console.warn('Currency bootstrap failed, using frontend defaults.', error?.message || error);
            }
        };

        syncCurrencySettings();
        return () => {
            isMounted = false;
        };
    }, []);

    return children;
}

function Provider({children}) {

    return (
        <ErrorBoundary>
            <CurrencyBootstrap>
                <AuthProvider>
                    <LanguageProvider>
                        <StoreProvider>
                            <ThemeProvider>
                                <SidebarProvider>
                                    <RealtimeProvider>
                                        {children}
                                    </RealtimeProvider>
                                </SidebarProvider>
                            </ThemeProvider>
                        </StoreProvider>
                    </LanguageProvider>
                </AuthProvider>
            </CurrencyBootstrap>
        </ErrorBoundary>
    )
}

Provider.propTypes = {
    children: PropTypes.node,
};

export default Provider;